export default "data:image/webp;base64,UklGRj4AAABXRUJQVlA4TDIAAAAvJ8AEAFATgBDURzkaiWq/dyXItoGb2fyGcJYTZhuZzWBI+5/19T8R72qV5X/Xroz4Lg=="